/**
 * ============================================================================
 * ROOT APPLICATION ENTRY COMPONENT
 * ============================================================================
 * Purpose:
 *   Top-level React application root. Providers ThemeProvider, Router, and
 *   mounts the modular domain route tree (`routes/index.jsx`).
 * ============================================================================
 */

import React from "react";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { ThemeProvider } from "./core/contexts/ThemeContext";
import AppRoutes from "./routes";

import "./App.css";

const Router = window.location.protocol === "file:" ? HashRouter : BrowserRouter;

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <Router>
          <AppRoutes />
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
